/**
 * datetime-local ↔ instante, sin perder la hora de la zona del usuario.
 * No usar new Date('YYYY-MM-DDTHH:mm') en Node (Cloud Run es UTC).
 */

export function parseTimestamp(value) {
    if (!value) return null;
    if (typeof value.toDate === 'function') return value.toDate();
    if (value._seconds != null) return new Date(value._seconds * 1000);
    if (value.seconds != null) return new Date(value.seconds * 1000);
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}

const pad = (n) => String(n).padStart(2, '0');

/** Valor para <input type="datetime-local"> en hora local del navegador. */
export function toDatetimeLocalValue(value) {
    if (!value) return '';
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value) && !/[zZ]|[+-]\d{2}:\d{2}$/.test(value)) {
        return value.slice(0, 16);
    }
    const date = parseTimestamp(value);
    if (!date) return '';
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** Convierte el valor del input a ISO con Z, usando la zona del navegador. */
export function datetimeLocalToIso(value) {
    if (!value) return null;
    const [datePart, timePart = '00:00'] = String(value).split('T');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hour, minute] = timePart.split(':').map(Number);
    if (![year, month, day].every(Number.isFinite)) return null;
    const date = new Date(year, (month || 1) - 1, day || 1, hour || 0, minute || 0, 0, 0);
    if (Number.isNaN(date.getTime())) return null;
    return date.toISOString();
}

export function formatDeadlineShort(value) {
    const date = parseTimestamp(value);
    if (!date) return '—';
    return date.toLocaleString('es-MX', {
        day: '2-digit',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
    });
}

export function deadlineTone(value) {
    const date = parseTimestamp(value);
    if (!date) return { label: 'Sin deadline', tone: 'muted', overdue: false };
    const startToday = new Date();
    startToday.setHours(0, 0, 0, 0);
    const startTarget = new Date(date);
    startTarget.setHours(0, 0, 0, 0);
    const days = Math.round((startTarget.getTime() - startToday.getTime()) / 86400000);
    const pretty = formatDeadlineShort(date);
    if (days < 0) return { label: pretty, tone: 'danger', overdue: true };
    if (days === 0) return { label: `Hoy · ${pretty}`, tone: 'warn', overdue: false };
    if (days <= 2) return { label: pretty, tone: 'warn', overdue: false };
    return { label: pretty, tone: 'ok', overdue: false };
}
